import React from 'react';

interface FitScoreBadgeProps {
  score: number;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
}

export default function FitScoreBadge({ score, size = 'md', showLabel = false }: FitScoreBadgeProps) {
  const color = score >= 85 ? 'text-positive bg-positive/10 border-positive/30'
    : score >= 70 ? 'text-warning bg-warning/10 border-warning/30' :'text-negative bg-negative/10 border-negative/30';

  const sizeMap = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2.5 py-1',
    lg: 'text-base px-3 py-1.5',
  };

  return (
    <span className={`inline-flex items-center gap-1 font-700 rounded-full border font-mono ${color} ${sizeMap[size]}`}>
      {showLabel && <span className="font-400 text-xs">Fit</span>}
      {score}%
    </span>
  );
}